module.exports = __webpack_public_path__ + "static/media/damlag_1366.216d3319.jpg";